module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consultation"
  }, [_c('com-list', {
    attrs: {
      "data": _vm.coStyle,
      "title": "合作形式"
    }
  }), _vm._v(" "), _c('co-area'), _vm._v(" "), _c('com-service'), _vm._v(" "), _c('com-tea'), _vm._v(" "), _c('com-partner', {
    attrs: {
      "partners": _vm.partners
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ff9410a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/consultation/consultation.vue
// module id = 460
// module chunks = 1